import { c as _c } from "react/compiler-runtime";
import type { VaultDataDeleted } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import FieldList from '@/pages/developers/security-logs/components/timeline/components/event/components/user-data/components/field-list';
import Actor from '../actor';
type VaultDataDeletedEventHeaderProps = {
  data: VaultDataDeleted;
};
const VaultDataDeletedEventHeader = t0 => {
  const $ = _c(18);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.vaultDataDeletedEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== data.actor) {
    t3 = <Actor actor={data.actor} />;
    $[3] = data.actor;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="text-tertiary">{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="flex items-center gap-1 text-body-2">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== data.deletedFields) {
    t7 = <FieldList fields={data.deletedFields} numVisibleFields={7} />;
    $[12] = data.deletedFields;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex justify-start items-center gap-1 flex-wrap" aria-label={t2}>{t6}{t7}</div>;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default VaultDataDeletedEventHeader;
function _temp($) {
  return $.ariaLabel;
}
function _temp2($_0) {
  return $_0.title;
}